import { useDuelAttention } from './useDuelAttention.js';

export function DuelNavBadge() {
  const attention = useDuelAttention();
  if (attention.total < 1) return null;
  return (
    <b
      className="nav-attention-badge"
      aria-label={`Дуэлей, ожидающих действия: ${attention.total}`}
    >
      {attention.total > 9 ? '9+' : attention.total}
    </b>
  );
}
